import Vue from 'vue'
import axios from 'axios'
import router from './router/index'
import store from './store'
import { sync } from 'vuex-router-sync'
import App from './components/app-root'
import { FontAwesomeIcon } from './icons'
import VueAuth from '@websanova/vue-auth'
import VueAxios from 'vue-axios'
import Notifications from 'vue-notification'
import BootstrapVue from 'bootstrap-vue'
import Loading from 'common/components/loading'
import LoadingSmall from 'common/components/loading-small'

////// Web Site Types (SKW / ACS) //////
import websiteType from 'common/website-type';

Vue.use(websiteType);




////// Styles //////
// Keep this in order to make printing styles working
import './css/main.scss'
// SCSS from common
import 'common/css/skw-light-bs.scss'
import 'common/css/skw-dark-bs.scss'
import 'common/css/acs-light-bs.scss'
import 'common/css/acs-dark-bs.scss'
import 'common/css/common.scss'
import 'common/css/common-light.scss'
import 'common/css/common-dark.scss'
import 'common/css/skw-common.scss'
import 'common/css/skw-light.scss'
import 'common/css/skw-dark.scss'
import 'common/css/acs-common.scss'
import 'common/css/acs-light.scss'
import 'common/css/acs-dark.scss'
import 'common/common.css'
// Comms Manager specific styles
import './css/site.css'



////// Debug //////
import debug from 'common/debug';

Vue.use(debug);


import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

import { loadLocaleMessages } from 'common/i18n'

var i18n = new VueI18n({
    locale: process.env.VUE_APP_I18N_LOCALE || 'en',
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
    messages: loadLocaleMessages()
});

// Registration of global components
Vue.component('font-awesome-icon', FontAwesomeIcon)

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.common['ACS-Application'] = 'CommsManagerWebsite';

Vue.use(VueAxios, axios);
Vue.use(Notifications);
Vue.use(BootstrapVue);

// The single-word component name break rule of vue
// This name is used through out the common vue project, so it has to be kept
// The error is suppress using the following comment
// eslint-disable-next-line
Vue.component('loading', Loading);
Vue.component('loading-small', LoadingSmall);

Vue.router = router;

Vue.use(VueAuth, {
    auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
    http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
    router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
    loginData: { url: 'authentication/request-token?ignoreWorkingClient=true', method: 'POST', redirect: '/', fetchUser: true },
    fetchData: { url: 'authentication/user?ignoreWorkingClient=true', method: 'GET', enabled: true },
    refreshData: { url: 'authentication/refresh-token?ignoreWorkingClient=true', method: 'GET', enabled: true, interval: 30 }
});

sync(store, router)

import SingalR from './signalr';
Vue.use(SingalR);

var app = new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')

export {
    app,
    router,
    store
}
